import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Youtube } from "lucide-react";
import { companyInfo } from "../data/mock";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-slate-700 rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-lg">
                HI
              </div>
              <div>
                <div className="font-bold text-white text-lg leading-tight">
                  Hero Impex
                </div>
                <div className="text-xs text-slate-400">
                  India Private Limited
                </div>
              </div>
            </div>
            <p className="text-sm mb-4">
              Leading manufacturer of coating, lamination, slitting, and converting machines since 1977. Trusted by 800+ clients across 20+ countries.
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 bg-slate-800 hover:bg-cyan-600 rounded-lg flex items-center justify-center transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-slate-800 hover:bg-cyan-600 rounded-lg flex items-center justify-center transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-slate-800 hover:bg-cyan-600 rounded-lg flex items-center justify-center transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 bg-slate-800 hover:bg-cyan-600 rounded-lg flex items-center justify-center transition-colors">
                <Youtube className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-cyan-400 transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-cyan-400 transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-cyan-400 transition-colors">Products</Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-cyan-400 transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-cyan-400 transition-colors">Contact Us</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Our Products</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/products" className="hover:text-cyan-400 transition-colors">BOPP Tape Coating Machine</Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-cyan-400 transition-colors">Slitting Rewinding Machine</Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-cyan-400 transition-colors">Tape Slicing Machine</Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-cyan-400 transition-colors">Film Slitting Machine</Link>
              </li>
              <li>
                <Link to="/products" className="hover:text-cyan-400 transition-colors">Air Knife Coating Machine</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-cyan-400" />
                <span>{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-cyan-400" />
                <a href={`tel:${companyInfo.phone}`} className="hover:text-cyan-400 transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0 text-cyan-400" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-cyan-400 transition-colors">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
            <div className="mt-4 p-3 bg-slate-800 rounded-lg">
              <div className="text-xs text-slate-400 mb-1">GST Number</div>
              <div className="text-sm font-mono">{companyInfo.gst}</div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <div>
              © {currentYear} Hero Impex India Private Limited. All rights reserved.
            </div>
            <div className="flex gap-6">
              <Link to="#" className="hover:text-cyan-400 transition-colors">Privacy Policy</Link>
              <Link to="#" className="hover:text-cyan-400 transition-colors">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
